import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { FormControl, Validators } from "@angular/forms";

export enum FileType {
  Pdf = "pdf",
  Csv = "csv"
}

const FILE_TYPES = [
  {
    value: FileType.Pdf,
    label: ".pdf file"
  },
  {
    value: FileType.Csv,
    label: ".csv file"
  }
];

@Component({
  selector: "onsip-download-directory-modal",
  templateUrl: "./download-directory-modal.component.html",
  styleUrls: ["./download-directory-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DownloadDirectoryModalComponent {
  fileTypes = FILE_TYPES;
  formControl = new FormControl("", [Validators.required]);

  constructor(public dialogRef: MatDialogRef<DownloadDirectoryModalComponent>) {}

  submitData(): void {
    this.formControl.markAsTouched();
    if (this.formControl.valid) {
      this.dialogRef.close(this.formControl.value);
    } else {
      return;
    }
  }
}
